import * as React from 'react'
import MuiThemeProvider from '@material-ui/core/styles/MuiThemeProvider'
import theme from '../src/themes/foosio'

const withMui = (story: () => React.ReactNode) => (
  <MuiThemeProvider theme={theme}>{story()}</MuiThemeProvider>
)

export default withMui
